<template>
    <div class="analysis-page">
        <div class="sub-container">
            <h1>Podcast </h1>
        </div>
        <div class="analysis-page-top" style="background: revert" v-if="playingPodcast">
            <div class="sub-container">
                <div class="analysis-top-list">
                    <div class="col-md-12 col-sm-12 video-container">
                        <iframe :src="playingPodcast.link" id="video-iframe"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="analysis-listing">
            <div class="sub-container">
                <div class="row">
                    <div class="col-md-8 col-sm-7">
                        <form>
                            <div class="analysis-listing-top search-row">
                                <div class="analysis-search">
                                    <input type="text" :placeholder="$t('search') " name="filter" id="filter"
                                           v-model="filter"/>
                                    <input style="display: none" type="text" name="keyword" v-model="selectedTopic"/>
                                </div>
                                <div class="analysis-topic">
                                    <label>{{ $t('topic') }}</label>
                                    <select dir="ltr" v-model="selectedTopic">
                                        <option value="">{{ $t('all') }}</option>
                                        <option v-for="keyword in keywords" :value="keyword.slug">
                                            {{ keyword.keyword_languages[0].pivot.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="search-btn" style="margin-left: 10px">
                                    <button type="submit">{{ $t('search') }}</button>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <podcast v-for="podcast in podcasts.data" :podcast="podcast"></podcast>
                        </div>
                        <div class="pagination-row">
                            <a class="paginate-link" :href="podcasts.links[0].url">&#60;</a>
                            <template v-for="(link, index) in podcasts.links">
                                <a class="paginate-link" :href="link.url"><p :class="{'active' : link.active}"
                                                                             v-if="index !== 0 && index !== podcasts.links.length - 1">
                                    {{ link.label }}</p></a>
                            </template>
                            <a class="paginate-link"
                               :href="podcasts.links[podcasts.links.length - 1].url">&#62;</a>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-5">
                        <div class="Subscribe-row" v-if="$store.state.language.code !== 'tr'">
                            <span>{{ $t('subscribe_to_our_newsletter') }}</span>
                            <form :action="$store.state.hrefPrefix + '/subscribe'" method="post" ref="subscribe"
                                  @submit.prevent="">
                                <input type="hidden" name="_token" :value="csrf">
                                <div class="Newsletter-input">
                                    <input type="text" :placeholder="$t('your_email_address')" name="email"/>
                                    <button class="g-recaptcha" data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                            data-callback="submitPodcastSubscribe">{{ $t('cap_subscribe') }}
                                    </button>
                                </div>
                            </form>
                        </div>

                        <most-popular :articles="mostPopularArticle"></most-popular>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import MostPopularArticle from "@/parts/home/MostPopularArticle.vue";

import MostPopular from "@/parts/home/MostPopular.vue";
import ColumnArticle from "@/parts/Columns/ColumnArticle.vue";
import DebatersArticle from "@/parts/Columns/DebatersArticle.vue";
import Poll from "@/parts/Poll.vue";
import Podcast from "@/parts/Podcast.vue";

export default {
    name: "PodcastsPage",
    components: {
        Podcast,
        Poll,
        DebatersArticle,
        ColumnArticle,
        MostPopular,
        MostPopularArticle,

    },
    props: {
        podcasts: {
            type: Array,
            default: []
        },
        playingPodcast: {
            type: Object,
            default: null
        },
        keywords: {
            type: Array,
            default: []
        },
        mostPopularArticle: {
            type: Object,
            default: []
        },

    },
    data() {
        return {
            //Get from query param
            filter: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            selectedTopic: null,
        }
    },
    computed: {
    },
    methods: {
        adjustIframeHeight() {
            // Get video-container width
            const videoContainer = document.getElementsByClassName('video-container')[0];
            // Get the height bey aspect ratio 16/9
            const height = videoContainer.offsetWidth * 9 / 16;
            // Set the height
            videoContainer.style.height = height + 'px';
            // Set the iframe height
            document.getElementById('video-iframe').style.height = height + 'px';
        },
        submitPodcastSubscribe(response) {
            console.log(response)
            const form = this.$refs.subscribe;
            form.submit();
        }
    },
    mounted() {
        window.submitPodcastSubscribe = this.submitPodcastSubscribe;
        const urlParams = new URLSearchParams(window.location.search);
        this.filter = urlParams.get('filter');
        this.selectedTopic = urlParams.get('keyword') ?? '';
        if (urlParams.get('start_date') && urlParams.get('end_date')) {
            this.selectedDateValue = urlParams.get('date_value') ?? 'all';
            this.selectedDates = {
                startDate: urlParams.get('start_date'),
                endDate: urlParams.get('end_date')
            }
        }
        this.adjustIframeHeight();
        window.addEventListener('resize', (event) => {
            this.adjustIframeHeight();
        }, true);
    },
    created() {
        console.log('TEST')
        console.log(this.podcasts)
        console.log(this.keywords)
        console.log(this.mostPopularArticle)
    }
}
</script>

<style scoped>

.video-container {
    position: relative;
    overflow: hidden;
}

.video-container iframe {
    top: 0;
    left: 0;
    width: 100%;
}

@media (max-width: 960px) {
    .analysis-page .analysis-page-top .analysis-top-list {
        white-space: nowrap;
        justify-content: flex-start;
        overflow: auto;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 2rem;
    }
}

@media (max-width: 575px) {
    .video-container iframe {
        width: 100%;
    }
}

@media (max-width: 575px) {
    .video-container {
        width: 100%;
        max-width: 560px;
        margin: 0 auto;
    }
}

.paginate-link:active, .paginate-link:hover, .paginate-link:focus, .paginate-link:visited, .paginate-link {
    color: #000;
}

.web-view-poll {
    display: block;
}

@media (max-width: 960px) {
    .web-view-poll {
        display: block !important;
    }
}

@media (max-width: 767px) {
    .web-view-poll {
        display: block !important;
    }
}

</style>
